export default __webpack_public_path__ + "static/media/blue-down-arrow.6a22596c.svg";